import { inject, Injectable } from "@angular/core";
import { GetThresholdGQL, GetThresholdQuery, UpdateIcsThresholdGQL, UpdateIcsEvaluationWeightsGQL, UpdateImpactThresholdGQL, UpdateLikelihoodThresholdGQL, Threshold, UpdateResidualRiskThresholdGQL, UpdateInherentRiskThresholdGQL, GetIcsEvaluationWeightsGQL, GetIcsEvaluationWeightsQuery, UpdateIcsEvaluationWeights, UpdateIcsEvaluationWeightsMutation, UpdateGiasRatingScaleGQL, UpdateKiRsRatingScaleGQL, RatingScaleThresholdInput, UpdateIcsEvaluationKpiThresholds } from "../../../graphql/generated";
import { forkJoin, map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class ThresholdService {
    private readonly GetThresholdGQL: GetThresholdGQL = inject(GetThresholdGQL)
    private readonly GetIcsEvaluationWeightsGQL: GetIcsEvaluationWeightsGQL = inject(GetIcsEvaluationWeightsGQL)
    private readonly UpdateIcsThresholdGQL: UpdateIcsThresholdGQL = inject(UpdateIcsThresholdGQL)
    private readonly UpdateImpactThresholdGQL: UpdateImpactThresholdGQL = inject(UpdateImpactThresholdGQL)
    private readonly UpdateLikelihoodThresholdGQL: UpdateLikelihoodThresholdGQL = inject(UpdateLikelihoodThresholdGQL)
    private readonly UpdateResidualRiskThresholdGQL: UpdateResidualRiskThresholdGQL = inject(UpdateResidualRiskThresholdGQL)
    private readonly UpdateInherentRiskThresholdGQL: UpdateInherentRiskThresholdGQL = inject(UpdateInherentRiskThresholdGQL)
    private readonly UpdateIcsEvaluationWeightsGQL: UpdateIcsEvaluationWeightsGQL = inject(UpdateIcsEvaluationWeightsGQL)
    private readonly UpdateGiasRatingScaleGQL: UpdateGiasRatingScaleGQL = inject(UpdateGiasRatingScaleGQL)
    private readonly UpdateKiRsRatingScaleGQL: UpdateKiRsRatingScaleGQL = inject(UpdateKiRsRatingScaleGQL)


    getTreshold(): Observable<GetThresholdQuery> {
        return this.GetThresholdGQL.fetch({},
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data));
    }
    getIcsWeights(icsCampaignId: string): Observable<GetIcsEvaluationWeightsQuery['getIcsEvaluationWeights']> {
        return this.GetIcsEvaluationWeightsGQL.fetch(
            { icsCampaignId },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data.getIcsEvaluationWeights));
    }

    // `thresholds` viaggia insieme ai pesi: se omesso le scale dei KPI restano quelle salvate.
    updateIcsWeights(icsCampaignId: string, weights: UpdateIcsEvaluationWeights, thresholds?: UpdateIcsEvaluationKpiThresholds): Observable<UpdateIcsEvaluationWeightsMutation['updateIcsEvaluationWeights']> {
        return this.UpdateIcsEvaluationWeightsGQL.mutate({
            icsCampaignId,
            weights,
            thresholds
        },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateIcsEvaluationWeights));
    }

    updateThresholdIcs(id: string, min: number, max: number, label: string, extendedLabel: string): Observable<Threshold[]> {
        return this.UpdateIcsThresholdGQL.mutate({ id, min, max, label, extendedLabel },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateICSThreshold as Threshold[]));
    }
    updateThresholdImpact(id: string, min: number, max: number, label: string, extendedLabel: string): Observable<Threshold[]> {
        return this.UpdateImpactThresholdGQL.mutate({ id, min, max, label, extendedLabel },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateImpactThreshold as Threshold[]));
    }
    updateThresholdLike(id: string, min: number, max: number, label: string, extendedLabel: string): Observable<Threshold[]> {
        return this.UpdateLikelihoodThresholdGQL.mutate({ id, min, max, label, extendedLabel },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateLikelihoodThreshold as Threshold[]));
    }
    updateThresholdRR(id: string, min: number, max: number, label: string, extendedLabel: string): Observable<Threshold[]> {
        return this.UpdateResidualRiskThresholdGQL.mutate({ id, min, max, label, extendedLabel },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateResidualRiskThreshold as Threshold[]));
    }
    updateThresholdIR(id: string, min: number, max: number, label: string, extendedLabel: string): Observable<Threshold[]> {
        return this.UpdateInherentRiskThresholdGQL.mutate({ id, min, max, label, extendedLabel },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateInherentRiskThreshold as Threshold[]));
    }

    updateThresholdGias(thresholds: RatingScaleThresholdInput[]): Observable<any> {
        return this.UpdateGiasRatingScaleGQL.mutate(
            { threshold: thresholds },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateGIASRatingScale));
    }

    updateThresholdKirs(thresholds: RatingScaleThresholdInput[]): Observable<any> {
        return this.UpdateKiRsRatingScaleGQL.mutate(
            { threshold: thresholds },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data?.updateKIRsRatingScale));
    }

    // updateIcsWeight(id: string, value: any): Observable<GetIcsEvaluationWeightsQuery[]> {
    //     return this.UpdateIcsEvaluationWeightsGQL.mutate({ id, value },
    //         { fetchPolicy: "no-cache" }
    //     ).pipe(map(result => result.data?.updateIcsEvaluationWeights as GetIcsEvaluationWeightsQuery[]));
    // }
}